var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWallet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.1631 1.28586C15.1366 1.00769 16.1513 1.57143 16.4295 2.54499C16.4763 2.70879 16.5 2.8783 16.5 3.04865V4.5834H18.3334C19.3459 4.5834 20.1667 5.40421 20.1667 6.41673V17.4167C20.1667 18.4293 19.3459 19.2501 18.3334 19.2501H3.66671C2.65419 19.2501 1.83337 18.4293 1.83337 17.4167H1.85785C1.84158 17.3182 1.83337 17.2183 1.83337 17.1181V6.19151C1.83337 5.37296 2.376 4.65358 3.16305 4.42871L14.1631 1.28586ZM9.29509 17.4167H18.3334V10.0834H16.5V13.9753C16.5 14.7938 15.9574 15.5132 15.1704 15.7381L9.29509 17.4167ZM18.3334 6.41673V8.25006H16.5V6.41673H18.3334ZM3.66671 6.19148V17.1181L14.6667 13.9753V3.04862L3.66671 6.19148ZM12.8334 8.25006C12.8334 8.75632 12.423 9.16673 11.9167 9.16673C11.4104 9.16673 11 8.75632 11 8.25006C11 7.7438 11.4104 7.3334 11.9167 7.3334C12.423 7.3334 12.8334 7.7438 12.8334 8.25006Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/wallet.d8cf44a83390f38ff52392863f65c08e.svg";
export { ForwardRef as ReactComponent };